'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (ResponsibleGamingMenuTabs) {
    ResponsibleGamingMenuTabs["LIMITS"] = "LIMITS";
    ResponsibleGamingMenuTabs["REALITY_CHECK"] = "REALITY_CHECK";
    ResponsibleGamingMenuTabs["TIME_OUT"] = "TIME_OUT";
    ResponsibleGamingMenuTabs["SELF_EXCLUDE"] = "SELF_EXCLUDE";
    ResponsibleGamingMenuTabs["PLAY_CONTROL"] = "PLAY_CONTROL";
})(exports.ResponsibleGamingMenuTabs || (exports.ResponsibleGamingMenuTabs = {}));
(function (ResponsibleGamingPage) {
    ResponsibleGamingPage["LIMITS"] = "limits";
    ResponsibleGamingPage["REALITY_CHECK"] = "reality-check";
    ResponsibleGamingPage["TIME_OUT"] = "time-out";
    ResponsibleGamingPage["SELF_EXCLUDE"] = "self-exclude";
    ResponsibleGamingPage["PLAY_CONTROL"] = "play-control";
})(exports.ResponsibleGamingPage || (exports.ResponsibleGamingPage = {}));
